module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4QsHDAoa9VyDuwAAANNJREFUSMft1jFKxEAUBuDPGLYQD+DaZO3FwgtolYtkbqDoaXIBvUJwrXUtBGuRgHgA12K30WIzkMYuSTU/PJhh4H0w1c8uOW7xgg1+B5oNVt3uXA97HBD5b5bIc1zjoigKdV37fD8wZI5PflRVpW3bS1ztdd943jTN4FjMfLFWliWsMpxiNAy+Pg7j8SzDzHSZZSZOAhOYwAQmMIEJ3IHbCb1thrfYrsbKfLGOx9cMdxBC6D8MlqPiWwghXu9jEV5OUIQfsN9v3zd4HqHqP3W7c/gDVrqCFoSIuaIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/territorio_zonasgn.png
// module id = 9CCP
// module chunks = 0